import React from 'react'
import { BrowserRouter as Router, Route, Redirect } from 'react-router-dom'
import Users2 from './users2.js'
import EnrolmentForm from './enrollmentForm.js'
import Login from './login.js'
import Programs2 from './programs2.js'
import Plans2 from './plans2.js'
import ArrayFormFields from './arrayFormFields.js'
import ProgramForm from './programForm.js'
import Transactions from './transactions.js'
import Portals from './portals'
import ParentPortal from './parentPortal'
import OrganizationForm from './organizationForm'
import Notifications from './notifications'
import Rosters from './board'
import Privacy from './privacy'
import Logout from './logout'
import ProgramRosters from './programRosters'
import UserProfile from './userProfile'
import LeagueEnrolment from './leagueEnrolment.js'
import OrganizationLandingPage from './organizationLandingPage'
import VerifyAge from "./VerifyAge"
import LinkRedirect from "./LinkRedirect"
import MasterBroadcast from './videoBroadcast/master'
import Broadcasts from './broadcasts.js'
import { getParams } from './helper'


class Routing extends React.Component {
  render() {
    return (
      <Router>
        <Route name="redirect" path="/r/:id" component={(routerProps) => <LinkRedirect history={this.props.history} linkId={routerProps.match.params.id}/>} />
        <Route name="Users" path="/users" component={Users2} />
        <Route name="Login" path="/" exact component={Login} />
        <Route name="Login" path="/login" component={Login} />
        {/* <Route path="/login" render={() => <Redirect to="/"/>}/> */}
        <Route name="Logout" path="/logout" component={Logout} />
        <Route name="Programs2" path="/programs2" component={Programs2} />
        <Route name="Privacy" path="/privacy" component={Privacy} />
        <Route name="LandingPage" path="/landing" component={OrganizationLandingPage} />
        <Route name="Plans" path="/plans" component={Plans2} />
        <Route name="Tester" path="/test" component={ArrayFormFields}/>
        <Route name="VerifyAge" path="/verify" component={VerifyAge}/>
        <Route name="MasterBroadcast" path="/broadcastMaster" component={Broadcasts}/>
        <Route name="ProgramForm" path="/programform" component={ProgramForm}/>
        <Route name="ProgramRosters" path="/programRosters" component={ProgramRosters}/>
        {/* <Route name="adminPortalDashboard" path="/adminportaldashboard" component={AdminPortalDashboard}/> */}
        {/* TODO: Change based on if the person is using Stripe */}
        <Route name="enrollmentForm" path="/enrollmentform" exact component={EnrolmentForm}/>
        <Route name="enrollment" path="/enrollment" exact component={EnrolmentForm}/>
        <Route
          name="enrollmentTest"
          path="/enrollment-test"
          exact
          render={(routeProps) => (
            <EnrolmentForm
              {...routeProps}
              testProgram={true}
            />
          )}
        />
        <Route name="Transactions" path="/transactions" component={Transactions} />
        <Route name="OrganizationDashboard" path="/portals" component={Portals} />
        <Route
          name="Family"
          path="/family"
          render={(props) => (
            <ParentPortal
              {...props}
              standaloneTab="family"
              organization_id={getParams().organization_id || localStorage.getItem('organization_id')}
            />
          )}
        />
        <Route name="organizationForm" path="/organizationform" component={OrganizationForm} />
        <Route name="notifications" path="/notifications" render={(props) => <Notifications {...props}/>}/>
        <Route name="rosters" path="/rosters" component={Rosters} />
        <Route name="broadcasts" path="/broadcast" component={MasterBroadcast} />
        <Route name="LeagueEnrolment" path="/leagueEnrolment" component={LeagueEnrolment} />
        <Route name="UserProfile" path="/userprofile" component={UserProfile} />
      </Router>
    );
  }
}

export default Routing;
